import styled from 'styled-components';
import { colors } from '../../../../../../styles/colors';

export const QuoteItem = styled.div`

    width: 100%;
    display: flex;
    position: relative;
    padding: 18px 0 0 4px;
    box-sizing: border-box;
    
    .title, .subtitle{
        font-weight: 700;
        color: ${colors.greenDarkViveo};
    }

    .title{
        font-size: 14px;
        margin-right: 50px;
    }

    .hintWarning {
        display: flex;
        width: 116px;
        font-size: 12px;
        color: #364863;
        text-decoration: underline;
        margin-top: 4px;
    }

    .hintOl {
        margin-top: 0;
        line-height: 15px;
    }

    .quantityMultiple{
        margin-top: 9px;
        font-size: 12px;
    }

    .quotes, .quoteQt, .headerQuoteItem, .rent, .unitValue, .totalValue .totalSubUnit, .radioArea{
        height: 100%;

        .value {
            display: flex;
            align-items: center;

            margin-top: 10px;
            margin-bottom: 2px;

            select {
                height: 30px;
                font-size: 11px;
                padding: 5px 5px;
            }

            input {
                border: 1px solid rgb(190, 190, 190) !important;
            }
        }
    }

    .btnArea{
        width: 45px;
        .button {
            height: 16px;
            padding: 0;
        }
    }

    .stock {
        width: 20px;
        display: flex;
        flex-direction: column;

        .value{    
            .tooltipMessage{
                color: ${colors?.red};
                overflow-wrap: break-word;
                max-width: 100px;
            }
            
        }
    }

    .quoteQt{
        width: 130px;

        .value{
            
            .tooltipMessage{
                color: ${colors?.red};
                overflow-wrap: break-word;
                max-width: 100px;
            }
            
        }
    }

    .radioArea{
        width: 220px;

        input[type="radio"] {
            width: 18px !important;
            height: 18px !important;
            border: #BEBEBE solid 1px;
        }

        input[type="radio"]:before {
            width: 18px !important; 
            height: 18px !important;
            border: #BEBEBE solid 1px;
        }

        input[type="radio"]:after {
            width: 18px !important; 
            height: 18px !important;
        }

        input[type="radio"]:checked:after {
            width: 10px !important; 
            height: 10px !important;
            top: 4.2px;
            left: 4.2px;
        }

        .inputArea{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }

        .select{
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 10px;
            label{
                padding-left: 6px;
                font-size: 12px;
                font-weight: 700;
                text-align: left;
            }
        }

        .selectDisabled{
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 10px;
            color: #7a7a7a;
            label{
                padding-left: 6px;
                font-size: 12px;
                font-weight: 500;
                text-align: left;
            }
    
            input[type="radio"]:before {
                background: #F2F2F2;
            }    
        }
    }

    .icons{
        justify-self: center;
        width: 50px;
        display: flex;
        flex-direction: row;

        .stock{
            img{
                margin: 2px 0 !important;
            }
        }

        .loadEditPriceHistory {
            margin-top: -11.6px;
        }

        .history{
            height: 17px;

            button{
                margin-top: -11.6px !important;
            }
        }
    }

    .containerColorSelected {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        
        width: 155px;
        margin-right: 10px;

        .headerQuoteItem {    
            .value{
                .tooltipMessage{
                    color: ${colors?.red};
                    overflow-wrap: break-word;
                    max-width: 100px;
                }
            }
        }
    }

    .quantityQuoteItem {
        min-width: 130px;
    }

    .rent{
        min-width: 120px;
        margin-left: 25px;

        .rentImg{
            grid-column-start: 0;
            grid-row-start: 3;
        }

        .subtitle{
            grid-column-start: 2;
            grid-row-start: 1;
        }

        .value{
            display: flex;
            grid-column-start: 2;
            height: 40px;
            align-items: baseline;

            .tooltipMessage{
                color: ${colors?.red};
                overflow-wrap: break-word;
                max-width: 100px;
            }
            
        }

        .rentWarningMessage{
            grid-column-start: 2;
            grid-row-start: 4;
        }
    }

    .unitValue{
        min-width: 120px;

        .value{
            span{
                margin-right: 2px;
            }
              
            .tooltipMessage{
                color: ${colors?.red};
                overflow-wrap: break-word;
                max-width: 100px;
            }
            
        }
    }    

    .totalValue{
        min-width: 120px;

        .value{
            margin-top: 18px;
        }
    }  

    .totalSubUnit{
        min-width: 134px;

        .value{
            margin-top: 18px;
        }
    }

    .obsFieldIcon {
        cursor: pointer;
        width: 27px;
    }

    .emptyObsFieldIcon {
        width: 27px;
    }

    .savedObsFieldIcon {
        width: 27px;
    }

    .lockIcon{
        position: relative;
        bottom: 70px;
        right: 22px;
        cursor: pointer;
    }

    .factoryPriceIcon{
        width: 12px;
        height: 12px;

        img{
            width: 17px;
        }
    }

    .answeredBionexo{
        width: 600px;
        position: relative;
        bottom: 0;
    }

    .messageAutoAnswer {
        font-weight: bold;
        white-space: normal;
        box-sizing: border-box;
        padding: 0 20px 20px 45px;

        span {
            color: #AD36F5;
        }
    }

    @media only screen and (max-width: 1420px) {
        .answeredBionexo {
            min-width: 600px;
        }
    }

    @media (max-width: 1110px){
        row-gap: 16px;
    }
`;